export const swalIconConstants = {
    Success : 'success',
    Error : 'error',
    Question : 'question',
    Info : 'info',
    Warning : 'warning',
}

export const commonConstants = {
    addButtonLabel : 'Add',
    filterSettingsType : 'Excel',
    toolbarType : 'Search',
    pageSettingsCount : 10,
    currentPage : 1,
    dataCount : 100,
    backButtonLabel : 'Back',
    resetButtonLabel : 'Reset',
    saveButtonLabel : 'Save',
    updateButtonLabel : 'Update',
    deleteYesLabel : 'Yes',
    deleteNoLabel : 'No',
    alertLabel : 'Alert',
    openDialogSize : '400px',
    statusList : [{ value: 'Active', id: 1 }, { value: 'Inactive', id: 0 }],
    deleteContent : '<small>Are you sure you want to delete this record?</small>',
}

export const baseColumnConfig = [
   
    {
      'field': 'status',
      'headerText': 'Status',
      'width': '150',
      'minWidth': '150',
      'text_align': 'Left',
      'isEditable': false,
      'isPrimaryKey': false
    },
    {
        'field': 'action',
        'headerText': 'Action',
        'width': '150',
        'minWidth': '150',
        'text_align': 'Left',
        'isEditable': false,
        'isPrimaryKey': false
      }
  ];
  
  export const idColumnConfig = [
    {
        'field': 's_no',
        'headerText': 'S.No',
        'width': '150',
        'minWidth': '150',
        'text_align': 'Left',
        'isEditable': false,
        'isPrimaryKey': true
      },
  ]
  
export const permissionURL = {
    abacURL : '/policy/abac/permissions'
}
